<p-dialog [(visible)]="stepChangeErrorDialogVisible" [draggable]="false" [modal]="true" showEffect="fade"
    [closable]="false" [style]="{width: '30vw'}" [breakpoints]="{'1098px': '50vw', '960px': '75vw'}" class="dialogPage"
    (visibleChange)="onVisibleChange($event)">
    <div class="grid">
        <div class="col-12" style="display: flex;justify-content: center;">
            <img style="width: 6rem;" src="/assets/vinter/icons/empty-result-list-svg.svg">
        </div>
        <div class="col-12 text-red-500 font-bold flex justify-content-center text-center text-2xl">
            <span class="ml-3">
                {{ 'Key.CurrentStepChange' | translate }}
            </span>
        </div>
        <div class="col-12 text-gray-500 flex justify-content-center text-center">
            <span class="ml-3">
                {{ 'Key.CurrentStepChangeError' | translate }}
            </span>
        </div>
        <div class="col-12 flex justify-content-center mt-3">
            <p-button label="{{ 'Key.Ok' | translate }}" styleClass="mr-2 mb-2" (click)="closeDialog()"></p-button>
        </div>
    </div>
</p-dialog>